// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3GuEs","inputWrap":"CustomTip_inputWrap__3mbZk"};